import { applyMiddleware, createStore, Store } from 'redux';
import { thunk, ThunkMiddleware } from 'redux-thunk';

import { AppActions } from './actions/types';
import { AppState, rootReducer } from './reducers';

const middleware = [thunk as ThunkMiddleware<AppState, AppActions>];
const enhancers = [applyMiddleware(...middleware)];
export default (): Store => createStore(rootReducer, undefined, ...enhancers);
